import React from 'react';
import cx from 'classnames';
import { Row, Col, Image, Panel, Media } from 'react-bootstrap';
import styles from './styles.module.scss';
import _ from 'lodash';
import { localizedStrings } from 'src/localization/index.jsx';
import Slider from 'src/components/slider';
import { AssetCard } from 'src/components/asset/add/card';
import Button from 'src/components/button';
import { AddAssetsFromHub } from 'src/legacy/components/add/hub';
import pluralize from 'pluralize';
import Text from 'src/components/text';

const DefaultAssetIcon='/images/defaultIcons/default_asset.jpg'
class ManageContentView extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {  
      assets: props.assets,
      collection: props.collection,
      addAssetState: {
        option: null,
        entities: [],
      },
      hasEntities: this.props.collection ? true : _.size(this.props.assets) > 0,
      chosenEntityType: this.props.collection ? 'collection' : 'asset',
      entities: this.props.collection ? [this.props.collection] : this.props.assets,
      show: this.props.show,
    }

    this.handleAssetRemove = this.handleAssetRemove.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);

    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizatedSettings = localizedStrings.pages.settings;
    this.localizedEmailTemplates = this.localizatedSettings.templates.email;
    this.localizedCompose = localizedStrings.components.compose;
  }

  componentWillReceiveProps(nextProps) {
    if (this.hasAssetsChanged(nextProps.entities, this.props.entities)) {
      const updatedAssets = nextProps.entities.map(item => item.entities);
      this.setState({
        hasEntities: true,
        entities: updatedAssets,
      })

      if(_.size(nextProps.entities) === 0) {
        this.setState({
          hasEntities: false,
        })
      } 
    }
  }

  handleAssetRemove(item) {
    const filteredEntities = this.state.entities.filter((entity) => entity.id !== item.id);
    this.setState({
      entities: filteredEntities,
    },() =>{
      if(_.size(this.state.entities) === 0) {
        this.setState({
          hasEntities: false,
        })
      }
    });
    if(item.entityType === 'collection') {
      this.props.removeCollectionSelection(item);
    }
  }

  handleSave() {
    if(this.state.chosenEntityType === 'collection') {
      this.props.onFinish(this.props.collection, this.props.collection.assets);
    }else{
      this.props.onFinish(this.props.collection, this.state.entities);
    }
  }

  handleCancel() {
    this.props.onCancel();
    this.props.invalidateAssetSelection();
    this.props.invalidateCollectionsSelection();
  }

  handleSelection(entity) {
    if (entity.entityType === 'asset') {
      this.props.invalidateCollectionsSelection();
      let assets = this.state.entities.filter((entity) => entity.entityType === "asset") || [];
      assets = [...assets, entity];
      assets = _.uniqBy(assets, 'id');

      this.setState({
        ...this.state,
        entities: assets,
        hasEntities: true,
        chosenEntityType: 'asset',
      });
    } else if (entity.entityType === 'collection') {
      this.props.invalidateCollectionsSelection();
      this.props.fetchFolio(entity.id);
      this.props.selectCollection(entity);
      this.setState({
        ...this.state,
        hasEntities: true,
        entities: [entity],
        chosenEntityType: 'collection',
      });
    }
  }

  render() {
    return (
      <div className={styles.addAsset}>
        <Slider.Dialog
        width={this.state.hasEntities ? "720px" : "380px"}
        height={345}
        show={true}
        onClose={() => this.handleCancel()}>
        <Slider.Header className={styles.header}>
        <div>
          <h5 className={styles.title}>streams & collections</h5>
          <p className={styles.decription}>
              Add assets from your streams & existing collections
          </p>
        </div>
      </Slider.Header>
        <Slider.Body className={styles.sliderBody}>
          <AddAssetsFromHub
            width={350}
            onSelection={(entity) => { 
              this.handleSelection(entity)
              }}
          />
          {
            this.state.hasEntities && <AssetSelection
            style={{}}
            removeCollectionSelection={this.props.invalidateCollectionsSelection}
            handleRemove={(entity) => this.handleAssetRemove(entity)}
            entities={this.state.entities}
            chosenEntityType={this.state.chosenEntityType}  
          />
          }
         
        </Slider.Body>
        <Slider.Actions>
          <Button
            text={this.localizedCommonActions.save}
            variant='primary'
            className={styles.confirm}
            onClick={this.handleSave}
            disabled={this.props.uploading}
            icon='paperflite-tick'
          >
          </Button>
          <Button
            text={this.localizedCommonActions.cancel}
            variant='secondary'
            className={cx(styles.updateAction, styles.cancel)}
            onClick={this.handleCancel} />
        </Slider.Actions>
      </Slider.Dialog>
      </div>
      
    );
  }

  renderAssets() {
    let items = this.props.assets.map((item) => {
      if (item.type == 'asset' && item.asset) {
        return (
          <li className={cx(styles.asset, styles.item)} key={`asset-${item.asset.id}`}>
            <span className={cx('lnr', 'lnr-cross', styles.closeButton)} onClick={this.handleAssetRemove.bind(this, item)}></span>
            <div className={styles.iconContainer}>
              <Image className={styles.icon} src={item.asset.icon ? item.asset.icon.thumbnail : DefaultAssetIcon} />
              {(item.asset.status == 'NEEDS_PROCESSING' || item.asset.status == 'PROCESSING') &&
                <div className={styles.status}>{this.localizedCommons.optimizing}</div>
              }
            </div>

            <div className={styles.name}>
              <Text lines={2} text={item.asset.name} />
            </div>
          </li>
        );
      }
    });


    items.push(
      (
        <li className={styles.item} key="emptyAsset">
          <div className={styles.emptyAsset}>&nbsp;</div>
        </li>
      )
    );


    return items;
  }

  hasAssetsChanged(a, b) {
    if (a === b) return false;
    if (a == null || b == null) return true;
    if (a.length != b.length) return true;

    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return true;
    }
    return false;
  }
}

ManageContentView.defaultProps = {
  collectionIconWidth: 240
};

export default ManageContentView;


class AssetSelection extends React.Component {

  constructor(props) {
    super(props);
    this.renderEntities = this.renderEntities.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  handleRemove(entity) {
    this.props.handleRemove(entity);
  }

renderEntities() {
  return (this.props.entities || []).map((entity, index) => {
    const entityType = _.get(entity, 'entityType');
      if (entityType === 'asset') {
      return (
        <AssetCard key={entity.id} asset={entity} editable={true} onRemove={this.handleRemove} />
      );
    } else if (entityType === 'collection') {
      return (
        <CollectionCard  key={entity.id} onRemove={this.handleRemove} collection={entity} width={200} />
      );
    }
  });
}
  render() {
    return (
      <div className={styles.entitySelectionContainer}>
        <div className={styles.entityHeader}>
          <h6 className={styles.title}>{_.size(this.props.entities)} {pluralize(_.get(this.props,"chosenEntityType","asset"),_.size(_.get(this.props,"entities",[])))}</h6>
        </div>
        <div className={styles.entities}>
        {this.renderEntities()}
        </div>
      </div>
    );
  }
}


const CollectionCard = (props) => {
  let iconStyle = {
    width: 250,
    height: 250
  }
  const getCollectionIcon = () => {
    var background = _.get(props.collection, 'banner.background');
    if (background && background.type == "image") {
      return background.full;
    } else if (background && background.type == "video") {
      return background.thumbnail;
    }

    return DefaultAssetIcon;
  }
  return (
    <div className={styles.collectionIcon} style={{ width: 250 }}>
      <span className={cx('paperflite-close', styles.closeButton)} onClick={() => {
        props.onRemove(props.collection);
      }}></span>
      <div className={styles.folder}>
        <div className={cx(styles.layer, styles.first)}>&nbsp;</div>
        <div className={cx(styles.layer, styles.second)}>&nbsp;</div>
        <div className={cx(styles.cover)}>
          <Image src={getCollectionIcon()} style={iconStyle} className={styles.icon} />

          <div className={styles.title}>{props.collection.name}</div>
          {props.collection.sectionsCount
            > 0 &&
            <div className={styles.sectionCount}>
              <strong>{props.collection.sectionsCount
              }</strong> {pluralize('section', props.collection.sectionsCount)}
            </div>
          }
          {props.collection.assetsCount > 0 &&
            <div className={styles.sectionCount}>
              <strong>{props.collection.assetsCount}</strong> {pluralize('asset', props.collection.assetsCount)}
            </div>
          }
        </div>
      </div>
    </div>
  )
}